let fields = [];
fields.push({ size: "1/2", type: "input", attribute: "dni" });
fields.push({ size: "1/2", type: "input", attribute: "name", validation: "required" });
fields.push({ size: "1/2", type: "input", attribute: "surname", validation: "required" });
fields.push({ size: "1/2", type: "input", attribute: "nickname" });

export default fields;